@if (isAuthenticated) {
  <app-version-nav></app-version-nav>
} @else {
  <app-header></app-header>
}
<div class="legal-container">
  <div class="legal-content">
    <h1>Terms and Conditions</h1>
    <p class="last-updated">Last Updated: {{ currentDate | date:'longDate' }}</p>

    <section class="legal-section">
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using the AIOptima platform ("Service"), you accept and agree to be bound by 
        the terms and provision of this agreement. If you do not agree to abide by the above, please 
        do not use this service.
      </p>
    </section>

    <section class="legal-section">
      <h2>2. Use License</h2>
      <p>
        Permission is granted to temporarily access the materials on AIOptima's platform for personal, 
        non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, 
        and under this license you may not:
      </p>
      <ul>
        <li>Modify or copy the materials</li>
        <li>Use the materials for any commercial purpose or for any public display</li>
        <li>Attempt to reverse engineer any software contained on AIOptima's platform</li>
        <li>Remove any copyright or other proprietary notations from the materials</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>3. User Accounts</h2>
      <p>
        When you create an account with us, you must provide information that is accurate, complete, 
        and current at all times. You are responsible for safeguarding the password and for all 
        activities that occur under your account.
      </p>
    </section>

    <section class="legal-section">
      <h2>4. Service Availability</h2>
      <p>
        We reserve the right to withdraw or amend our Service, and any service or material we provide 
        via the Service, in our sole discretion without notice. We will not be liable if, for any reason, 
        all or any part of the Service is unavailable at any time or for any period.
      </p>
    </section>

    <section class="legal-section">
      <h2>5. Intellectual Property</h2>
      <p>
        The Service and its original content, features, and functionality are and will remain the 
        exclusive property of AIOptima and its licensors. The Service is protected by copyright, 
        trademark, and other laws.
      </p>
    </section>

    <section class="legal-section">
      <h2>6. Limitation of Liability</h2>
      <p>
        In no event shall AIOptima, nor its directors, employees, partners, agents, suppliers, or 
        affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, 
        including without limitation, loss of profits, data, use, goodwill, or other intangible losses, 
        resulting from your use of the Service.
      </p>
    </section>

    <section class="legal-section">
      <h2>7. Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold harmless AIOptima and its licensee and licensors, 
        and their employees, contractors, agents, officers and directors, from and against any and 
        all claims, damages, obligations, losses, liabilities, costs or debt, and expenses.
      </p>
    </section>

    <section class="legal-section">
      <h2>8. Changes to Terms</h2>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
        If a revision is material, we will provide at least 30 days notice prior to any new terms 
        taking effect.
      </p>
    </section>

    <section class="legal-section">
      <h2>9. Contact Information</h2>
      <p>
        If you have any questions about these Terms and Conditions, please contact us through our 
        platform or support channels.
      </p>
    </section>
  </div>
</div>
